import { ApiInitiatorDto } from '../../base-dtos';

export interface GoalReviewCommentDto {
  id: string;
  goalId: string;
  comment: string;
  actor: ApiInitiatorDto;
  createdAt: Date;
}
